export default "__VITE_ASSET__d812dbd5__"